// lib/evaluation.ts — Text comparison and evaluation (pure functions)

export function normalizeText(text: string): string {
    return text.toLowerCase()
        .replace(/[^\w\s]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
}

export function calculateSimilarity(a: string, b: string): number {
    const wordsA = a.split(/\s+/);
    const wordsB = b.split(/\s+/);
    if (wordsB.length === 0) return 1;

    let matches = 0;
    for (const word of wordsA) {
        if (wordsB.includes(word)) matches++;
    }
    return matches / wordsB.length;
}

export function checkKeyWords(expected: string, heard: string): number {
    const stopWords = ['the', 'a', 'an', 'is', 'are', 'was', 'were', 'to', 'of', 'in', 'for', 'on', 'with', 'at', 'by', 'i', 'you', 'it', 'that', 'this'];
    const expectedWords = normalizeText(expected).split(/\s+/).filter(w => !stopWords.includes(w) && w.length > 2);
    const heardWords = normalizeText(heard).split(/\s+/);

    if (expectedWords.length === 0) return 1;

    let matches = 0;
    for (const word of expectedWords) {
        if (heardWords.some(h => h.includes(word) || word.includes(h))) matches++;
    }
    return matches / expectedWords.length;
}
